import isPermissionEnabled from "common/isPermissionEnabled"
import Breadcrumbs from "components/Common/Breadcrumb"
import Filters from "components/Common/Filters"
import Paginations from "components/Common/Paginations"
import DataExportDropdown from "components/Shared/DataExportDropdown"
import DownloadCSV from "components/Shared/DownloadCSV"
import DownloadXLSX from "components/Shared/DownloadXLSX"
import TableShimmer from "components/Shared/TableShimmer"
import formatDateTime from "components/Shared/formatDateTime"
import { pdfDownload } from "helpers/api_helper"
import { EXPORT_DATA } from "helpers/url_helper"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Card, CardBody, Col, Row, Table } from "reactstrap"
import { getAllCouponUsage } from "store/actions/promotionsAction"

const CouponUsage = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t("Coupon Usage | Namq")

  const dispatch = useDispatch()
  const location = useLocation()
  const { couponUsageId } = useParams()

  const searchParams = new URLSearchParams(location.search)
  const pageNumber = parseInt(searchParams.get("page")) || 1
  const navigate = useNavigate()

  const {
    loading,
    couponsItemsPerPage: itemsPerPage,
    totalCount,
    totalPages,
    currentPage,
    isUpdating,
    isLoading,
    couponUsage,
  } = useSelector(state => state.Promotions)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      14,
      "promotion_1",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
    })
  }, [userRole])

  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "")
  const [isApiCalled, setIsApiCalled] = useState(false)

  const [selectedFilters, setSelectedFilters] = useState({
    sortOrder: parseInt(searchParams.get("sortOrder") || "2"),
    coupon: "",
  })

  useEffect(() => {
    fetchCouponUsage()
  }, [mode])

  const fetchCouponUsage = () => {
    const { sortOrder } = selectedFilters

    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      orderBy: sortOrder,
      keyword: searchTerm,
      coupon: mode === "couponUsage" ? couponUsageId : "",
    }
    dispatch(getAllCouponUsage(payload))
    setIsApiCalled(true)
  }

  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
  }
  const filters = [
    {
      name: "sortOrder",
      type: "select",
      options: [
        { label: t("Ascending"), value: 1 },
        { label: t("Descending"), value: 2 },
      ],
      placeholder: t("Ascending"),
    },
  ]

  const handleFilterChange = (selectedValue, filterName) => {
    setSelectedFilters(prevFilters => ({
      ...prevFilters,
      [filterName]: selectedValue,
    }))
  }

  const getApiCall = (page = 1) => {
    const { sortOrder } = selectedFilters

    const searchParams = new URLSearchParams()
    searchParams.set("search", searchTerm)
    searchParams.set("sortOrder", sortOrder.toString())
    searchParams.set("page", page.toString())

    const payload = {
      perPage: itemsPerPage,
      pageNo: page,
      orderBy: Number(sortOrder),
      keyword: searchTerm || "",
      coupon: mode === "couponUsage" ? couponUsageId : "",
    }

    return dispatch(getAllCouponUsage(payload))
      .then(action => {
        const { statusCode, status } = action?.payload
        if (statusCode === 200 && status) {
          const path =
            mode === "couponUsage"
              ? `/coupon-usage/${couponUsageId}`
              : `/coupon-usage`
          navigate(`${path}?${searchParams.toString()}`)
        }
      })
      .catch(error => {
        console.error(error)
      })
  }

  const handleSearch = () => {
    getApiCall() // Default page = 1
  }

  const onPageChange = page => {
    getApiCall(page)
  }

  // useEffect(() => {
  //   if (isApiCalled) {
  //     const delayDebounceFn = setTimeout(() => {
  //       handleSearch()
  //     }, 500)

  //     return () => clearTimeout(delayDebounceFn)
  //   }
  // }, [searchTerm])

  // useEffect(() => {
  //   if (isApiCalled) {
  //     handleSearch()
  //   }
  // }, [selectedFilters])

  const handleReset = () => {
    const payload = {
      perPage: itemsPerPage,
      pageNo: pageNumber,
      orderBy: 2,
      keyword: "",
      coupon: mode === "couponUsage" ? couponUsageId : "",
    }
    dispatch(getAllCouponUsage(payload))
    setSelectedFilters({
      sortOrder: 2,
      //   coupon: "",
    })
    setSearchTerm("")
    mode === "couponUsage"
      ? navigate(`/coupon-usage/${couponUsageId}?page=${1}`)
      : navigate(`/coupon-usage?page=${1}`)
  }

  const handleExcelDownload = async () => {
    const { status } = selectedFilters

    const payload = {
      status: 1,
      keyword: searchTerm || "",
      type: "COUPON-USAGE",
      exportType: "xlsx",
      coupon: mode === "couponUsage" ? couponUsageId : "",
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const xlsxData = response
      DownloadXLSX(xlsxData, "Coupon Usage")
    }
  }

  const exportToCSV = async () => {
    const { status } = selectedFilters

    const payload = {
      status: 1,
      keyword: searchTerm || "",
      type: "COUPON-USAGE",
      exportType: "csv",
      coupon: mode === "couponUsage" ? couponUsageId : "",
    }
    const response = await pdfDownload(EXPORT_DATA, payload)
    if (response) {
      const csvData = response
      DownloadCSV(csvData, "Coupon Usage")
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {mode !== "couponUsage" && <Breadcrumbs />}
        <Row>
          <Col xl={12}>
            <Card>
              <DataExportDropdown
                cardTitle={t("Coupon Usage")}
                isExportData={loading ? false : true}
                onDownloadCSV={exportToCSV}
                onDownloadExcel={handleExcelDownload}
              />
              <CardBody>
                {/* {!loading && ( */}
                <Filters
                  filters={filters}
                  searchTerm={searchTerm}
                  handleSearchChange={handleSearchChange}
                  handleFilterChange={handleFilterChange}
                  handleSearch={handleSearch}
                  onReset={handleReset}
                  selectedFilters={selectedFilters}
                  searchBy={t("Code")}
                />

                <div className="table-responsive">
                  {loading ? (
                    <TableShimmer row={7} col={7} />
                  ) : couponUsage.length === 0 ? (
                    <p className="text-center my-2">
                      {t("No coupons usage found")}
                    </p>
                  ) : (
                    <Table className="table mb-0 capitalize_td" hover>
                      <thead className="table-light">
                        <tr>
                          <th>{t("S. No.")}</th>
                          <th>{t("Coupon Code")}</th>
                          <th>{t("Coupon Name")}</th>
                          <th>{t("User")}</th>
                          <th>{t("Branch Name")}</th>
                          <th>{t("Order Date")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {couponUsage?.map((item, index) => (
                          <tr
                            key={item._id}
                            onClick={() =>
                              navigate(`/coupon-usage/details?id=${item._id}`)
                            }
                            className="cursor-pointer"
                          >
                            <th scope="row">
                              {(currentPage - 1) * 10 + index + 1}
                            </th>
                            <td>{item?.coupon?.code}</td>
                            <td>
                              {language === "sa"
                                ? item?.coupon?.nameAr
                                : item?.coupon?.name}
                            </td>
                            <td>{`${item?.userId?.firstName} ${item?.userId?.lastName}`}</td>
                            <td>
                              {language === "sa"
                                ? item?.branchId?.nameAr
                                : item?.branchId?.name}
                            </td>
                            <td>{formatDateTime(item?.order?.orderDate)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  )}
                </div>
                {!loading && (
                  <div className="mt-3">
                    <Paginations
                      data={couponUsage}
                      itemsPerPage={itemsPerPage}
                      onPageChange={onPageChange}
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default CouponUsage
